var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkelpEducationTrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.37 93.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9aa21;}.cls-2{fill:#fff;}.cls-3{opacity:.65;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.76,
    y: 3.86,
    width: 85.85,
    height: 85.85,
    rx: 5.1,
    ry: 5.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m90.5,5.42c1.95,0,3.54,1.59,3.54,3.54v75.64c0,1.95-1.59,3.54-3.54,3.54H14.86c-1.95,0-3.54-1.59-3.54-3.54V8.96c0-1.95,1.59-3.54,3.54-3.54h75.64m0-1.56H14.86c-2.82,0-5.1,2.29-5.1,5.1v75.64c0,2.82,2.29,5.1,5.1,5.1h75.64c2.82,0,5.1-2.29,5.1-5.1V8.96c0-2.82-2.29-5.1-5.1-5.1h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m57.67,36.61c0-1.88-1.53-3.42-3.42-3.42h-23.45c-3.02,0-5.48,2.46-5.48,5.48v17.35h3.78v18.27h13.56v-34.26h11.58c1.88,0,3.42-1.53,3.42-3.42Zm-16.83,1.59v34.26h-4.03v-15.62h-1.83v15.62h-4.03v-20.46h-1.83v2.19h-1.95v-15.51c0-2.01,1.64-3.65,3.65-3.65h23.45c.87,0,1.59.71,1.59,1.59s-.71,1.59-1.59,1.59h-13.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m35.89,31.52c2.86,0,5.18-2.32,5.18-5.18s-2.32-5.18-5.18-5.18-5.18,2.32-5.18,5.18,2.32,5.18,5.18,5.18Zm0-8.53c1.85,0,3.35,1.5,3.35,3.35s-1.5,3.35-3.35,3.35-3.35-1.5-3.35-3.35,1.5-3.35,3.35-3.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.15 25.42 43.15 27.26 78.21 27.26 78.21 51.99 46.39 51.99 46.39 53.82 80.04 53.82 80.04 25.42 43.15 25.42"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.34,
    y: 40.34,
    width: 12,
    height: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.34,
    y: 34.72,
    width: 12,
    height: 1.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.81,
    y: 45.96,
    width: 19.53,
    height: 1.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m60.47,61.63c0-2.07-1.69-3.76-3.76-3.76s-3.76,1.69-3.76,3.76,1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76Zm-5.69,0c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93-.86,1.93-1.93,1.93-1.93-.86-1.93-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.86,67.25h-8.11c-.99,0-1.87.43-2.49,1.1-.62-.67-1.5-1.1-2.49-1.1h-8.11c-1.88,0-3.41,1.53-3.41,3.41v4.98h1.83v-4.98c0-.87.71-1.58,1.58-1.58h8.11c.87,0,1.57.71,1.57,1.57h0v4.99h1.83v-4.98c0-.87.71-1.58,1.58-1.58h8.11c.87,0,1.57.71,1.57,1.57v4.99h1.83v-4.99c0-1.88-1.53-3.4-3.41-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.56,61.63c0-2.07-1.69-3.76-3.76-3.76s-3.76,1.69-3.76,3.76,1.69,3.76,3.76,3.76,3.76-1.69,3.76-3.76Zm-5.69,0c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93-.86,1.93-1.93,1.93-1.93-.86-1.93-1.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkelpEducationTrain);
export default __webpack_public_path__ + "static/media/SKELP_EducationTrain.e1fa5c83ea06c4be72e65943289c2347.svg";
export { ForwardRef as ReactComponent };